import { tw } from '@backmarket/utils/string/tw'

export type TextColor =
  | 'Black'
  | 'Bush'
  | 'Coffee Bean'
  | 'Cornflower Blue'
  | 'Deep Blush'
  | 'Emerald'
  | 'Medium Purple'
  | 'Mindaro'
  | 'Tangaroa'
  | 'Violet'
  | 'White'

export const colorClasses: Record<TextColor, string> = {
  Black: tw`text-static-default-hi`,
  Bush: tw`mood-emerald text-static-default-mid`,
  'Coffee Bean': tw`mood-blush text-static-default-mid`,
  'Cornflower Blue': tw`mood-tangaroa text-static-default-mid`,
  'Deep Blush': tw`mood-coffee text-static-default-mid`,
  Emerald: tw`mood-bush text-static-default-mid`,
  'Medium Purple': tw`mood-violet text-static-default-mid`,
  Mindaro: tw`mood-coffee text-static-default-hi`,
  Tangaroa: tw`mood-cornflower text-static-default-hi`,
  Violet: tw`mood-purple text-static-default-mid`,
  White: tw`text-static-light-hi`,
}
